<template>
    <div class="">
        <div class="flex flex-wrap">
            <div class="w-full flex flex-wrap sm:flex-nowrap">
                <input-text
                    class="sm:mr-2"
                    placeholder="First name"
                    :error-message="errors && errors['0.first_name'] ? 'The first name field is required' : ''"
                    v-model="orderStore.user.first_name"
                    @input="inputForm"

                />

                <input-text
                    placeholder="Last name"
                    :error-message="errors && errors['0.last_name'] ? 'The last name field is required' : ''"
                    v-model="orderStore.user.last_name"
                    @input="inputForm"

                />
            </div>

            <div class="w-full flex flex-wrap sm:flex-nowrap">
                <input-text
                    type="email"
                    class="sm:mr-2"
                    placeholder="Email"
                    :error-message="errors && errors['0.email'] ? 'The email field is required' : ''"
                    v-model="orderStore.user.email"
                    @input="inputForm"

                />

                <input-text
                    type="tel"
                    placeholder="Mobile No."
                    :error-message="errors && errors['0.phone_number'] ? 'The Mobile No. field is required' : ''"
                    v-model="orderStore.user.phone_number"
                    @input="inputForm"

                />
            </div>
        </div>

        <div class="flex justify-center ml-auto md:justify-end w-1/2">
            <button
                v-if="!loading && !paymentData.showComponent"
                :class="paymentData.privacy ? 'w-full justify-center lg:w-1/2 pointer text-center font-semibold text-white text-2xl uppercase flex items-center py-4 px-12 rounded-lg bg-lime-500' : 'w-full justify-center lg:w-1/2 pointer text-center font-semibold text-white text-2xl uppercase flex items-center py-4 px-12 rounded-lg bg-gray-400 pointer-events-none'"
                @click="openCardForms"
            >
                Continue
            </button>

            <button
                v-if="loading && !paymentData.showComponent"
                class="w-full justify-center lg:w-1/2 pointer text-center font-semibold text-white text-2xl uppercase flex items-center py-4 px-12 rounded-lg bg-lime-500"
                disabled
            >
                Loading...
            </button>
        </div>
    </div>
</template>

<script>
import ProductInfo from "@/views/home-pages/book-pages/ProductInfo";
import TextInput from "@/components/ui/TextInput";
import EmailInput from "@/components/ui/EmailInput";
import NumberInput from "@/components/ui/PhoneInput";
import InputText from "@/components/ui/inputs/InputText";
import InputSelect from "@/components/ui/inputs/InputSelect";
import {mapGetters} from "vuex";
import _ from "lodash";
import {loadStripe} from "@stripe/stripe-js";
import moment from "moment";
import {useI18n} from "vue-i18n/dist/vue-i18n";
import PurchaseCheckoutResult from "@/views/purchase/checkout/PurchaseCheckoutResult";
import {setOrderData} from "@/views/purchase/_store/actions";
import {useShipmentStore} from "@/store/shipmentStore";
import {useDestinationStore} from "@/store/destinationStore";
import {useOrderStore} from "@/store/orderStore";

export default {
    name: "PurchaseCheckoutForm",

    components: {InputSelect, InputText, NumberInput, EmailInput, TextInput, ProductInfo},

    setup() {
        const { t } = useI18n({
            useScope: 'global'
        })
        const destinationStore = useDestinationStore();
        const orderStore = useOrderStore();
        const shipmentStore = useShipmentStore();

        return { t, orderStore, destinationStore, shipmentStore }
    },

    computed: {
        ...mapGetters({
            user: 'getUser',
            paymentData: 'getPaymentData',
            orderData: 'purchase/getOrderData',
            orderTotalAmount: 'purchase/getOrderTotalAmount',
            deductedAmount: 'getDeductedAmount'
        }),
    },

    data() {
        return {
            form: {
                first_name: '',
                last_name: '',
                email: '',
                phone_number: '',
            },
            errors: {
                phone_number: [''],
                email: [''],
                first_name: [''],
                last_name: [''],
            },
            loading: false,

        }
    },

    created() {
        this.setUserFormData();
    },

    methods: {
        setUserFormData() {
            // let orderData = _.cloneDeep(this.orderData);

            // if (this.user && this.user.id) {
            //     this.form.first_name = this.user.first_name;
            //     this.form.last_name = this.user.last_name;
            //     this.form.email = this.user.email;
            //     this.form.phone_number = this.user.phone_number;
            // }

            // orderData.forEach((order, i) => {
            //     order.first_name = this.form.first_name;
            //     order.last_name = this.form.last_name;
            //     order.email = this.form.email;
            //     order.phone_number = this.form.phone_number;
            // });

            // this.$store.dispatch('purchase/setOrderData', orderData);
        },

        inputForm: _.debounce(function (e) {
            let orderData = _.cloneDeep(this.orderData);

            orderData.forEach((order, i) => {
                order.first_name = this.form.first_name;
                order.last_name = this.form.last_name;
                order.email = this.form.email;
                order.phone_number = this.form.phone_number;
            });

            this.$store.dispatch('purchase/setOrderData', orderData);
        }, 300),

        // routeTo() {
        //     this.$store.dispatch('setAuthResultType', 'purchase-checkout');
        //     this.$router.push({name: 'Login'});
        // },

        openCardForms() {
            this.loading = true;

            // let orderData = _.cloneDeep(this.orderData);
            // orderData = orderData.map((order) => {
            //     order.client_key = Math.random().toString(36).substring(2,7);
            //     return order;
            // })
            // this.$store.dispatch('purchase/setOrderData', orderData);

            this.$axios.post(`/orders/create-order`, this.orderStore.orderForm)
                .then(res => {
                    console.log('openCardForms', res.data)
                    this.orderStore.order_id = res.data.order_id;
                    this.orderStore.user_id = res.data.user_id;
                    // let orders = this.parseOrders(res.data);
                    // this.$store.dispatch('purchase/setOrderData', orders);

                    // if (this.isAllOrdersZeroTotalAmount(orders)) {
                    //     this.$router.push({name: 'PurchaseCheckoutResult'});
                    // } else {
                    let paymentData = _.cloneDeep(this.paymentData);
                    paymentData.showComponent = true;
                    this.$store.dispatch('setPaymentData', paymentData);
                    // }

                    this.loading = false;
                })
                .catch(e => {
                    this.$toast.warning(e.data.message, {
                        position: "bottom-left",
                    });

                    this.loading = false;
                });

            return;

            const hasOrderWithPositiveTotal = this.allOrderData.some(order => order.total_amount > 0);
            if(!hasOrderWithPositiveTotal) {
                const updatedForm = form.map(item => {
                    return {
                        ...item,
                        deducted_amount_balance: this.deductedAmount
                    };
                });
                this.$axios.post(`/orders/create-order`, updatedForm)
                    .then(res => {
                        this.allOrderData.forEach((order, i) => {
                            this.$store.dispatch('setDestinationIndex', i)

                            let paymentData = _.cloneDeep(this.paymentData);
                            const data = {
                                order_id: res.data[i].order_id,
                                customer_id: res.data[i].customer_id,
                            };
                            paymentData.showComponent = false;
                            this.$store.dispatch('setSameOrderData', { destinationIndex: i, data });
                            this.$store.dispatch('setPaymentData', paymentData);
                            this.$store.dispatch('setGiftCardDiscount', 0)
                            this.$router.push({name: 'PurchaseCheckoutResult'});
                            if (i === this.allOrderData.length - 1) {
                                this.loading = false;
                            }
                        })
                    })
                    .catch(e => {
                        this.allOrderData.forEach((order, i) => {
                            if (e.status === 422) {
                                this.errors = e.data.errors;
                            } else {
                                console.log(e);
                            }
                            if (i === this.allOrderData.length - 1) {
                                this.loading = false;
                            }
                        })
                    });
            } else {
                this.$axios.post(`/orders/create-order`, form)
                    .then(res => {
                        this.allOrderData.forEach((order, i) => {
                            this.$store.dispatch('setDestinationIndex', i)

                            let paymentData = _.cloneDeep(this.paymentData);
                            const data = {
                                order_id: res.data[i].order_id,
                                customer_id: res.data[i].customer_id,
                            };
                            paymentData.showComponent = true;
                            this.$store.dispatch('setSameOrderData', { destinationIndex: i, data });
                            this.$store.dispatch('setPaymentData', paymentData);

                            if (i === this.allOrderData.length - 1) {
                                this.loading = false;
                            }
                        })
                    })
                    .catch(e => {
                        this.allOrderData.forEach((order, i) => {
                            if (e.status === 422) {
                                this.errors = e.data.errors;
                            } else {
                                console.log(e);
                            }
                            if (i === this.allOrderData.length - 1) {
                                this.loading = false;
                            }
                        })
                    });
            }
        },
        getOrderData() {
            const orders = [];
            const orderData = {};
            const destinations = this.destinationStore.selectedDestinations;
            const plans = this.orderStore.plans;
            destinations.forEach((destination, i) => {
                orderData['country_id'] = destination.id;
                orderData['plan_id'] = plans[i]?.id || null;

                orders.push(_.cloneDeep(orderData));
            });

            return orders;
        },

        parseOrders(orders) {
            let parsedOrders = [];

            this.orderData.forEach((orderDataItem, i) => {
                let parsedOrder = orderDataItem;
                let findOrder = orders.find(order => {
                    return order.client_key === orderDataItem.client_key;
                })

                if (findOrder) {
                    parsedOrder['order_id'] = findOrder.order_id;
                    parsedOrder['customer_id'] = findOrder.customer_id;
                }

                parsedOrders.push(parsedOrder);
            })

            return parsedOrders;
        },

        isAllOrdersZeroTotalAmount(orders) {
            let value = true;
            orders.forEach(order => {
                if (order.total_amount > 0) value = false;
            });

            return value;
        }
    }
}
</script>

<style lang="scss">

</style>